import { Modal } from 'components/layouts/modal/modal'
import { FC, memo } from 'react'
import { TaskTemplateEntryForm } from './components/taskTemplateEntryForm/taskTemplateEntryForm'
import { TreeListTaskTemplateTask } from './components/taskTemplateEntryForm/components/taskTemplateTaskListAndEntryForm/taskTemplateTaskListAndEntryForm'

export type TaskTemplateEntryDialogProps = (
  | {
      isEditMode: false
      initialTaskTemplateTasks?: TreeListTaskTemplateTask[]
      taskTemplateId?: never
    }
  | {
      isEditMode: true
      taskTemplateId: string
      initialTaskTemplateTasks?: never
    }
) & {
  title: string
  projectId: string
  onSubmit: () => void
  isOpen: boolean
  onClose: () => void
  onDeleted: () => void
}

export const TaskTemplateEntryDialog: FC<TaskTemplateEntryDialogProps> = memo(
  (props) => {
    return (
      <Modal
        title={props.title}
        isOpen={props.isOpen}
        onClose={props.onClose}
        className="lg:min-w-[80vw]"
      >
        <TaskTemplateEntryForm
          isEditMode={props.isEditMode}
          projectId={props.projectId}
          taskTemplateId={props.taskTemplateId}
          initialTaskTemplateTasks={props.initialTaskTemplateTasks}
          onSubmit={props.onSubmit}
          onDeleted={props.onDeleted}
          onCancel={props.onClose}
        />
      </Modal>
    )
  }
)
